module.exports = __webpack_public_path__ + "static/media/Element_17_treatments.d217f1d9.svg";